/**
 * Size Chart Popup Modal
 * Handles the click-to-zoom functionality for size chart images
 */

class SizeChartPopup {
  constructor() {
    this.modal = null;
    this.modalImage = null;
    this.closeBtn = null;
    this.init();
  }

  init() {
    // Create modal elements if they don't exist
    this.createModal();
    
    // Add event listeners to size chart images
    this.attachEventListeners();
  }

  createModal() {
    // Check if modal already exists
    if (document.getElementById('sizeChartModal')) {
      this.modal = document.getElementById('sizeChartModal');
      this.modalImage = document.getElementById('sizeChartModalImage');
      this.closeBtn = document.getElementById('sizeChartClose');
      return;
    }

    // Create modal HTML
    const modalHTML = `
      <div id="sizeChartModal" class="size-chart-modal">
        <div class="size-chart-modal-content">
          <button id="sizeChartClose" class="size-chart-close" aria-label="Close size chart">&times;</button>
          <img id="sizeChartModalImage" class="size-chart-modal-image" src="" alt="Size Chart">
        </div>
      </div>
    `;

    // Insert modal at the end of body
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // Get references to modal elements
    this.modal = document.getElementById('sizeChartModal');
    this.modalImage = document.getElementById('sizeChartModalImage');
    this.closeBtn = document.getElementById('sizeChartClose');

    // Add close button event listener
    this.closeBtn.addEventListener('click', () => this.closeModal());

    // Close modal when clicking outside the image
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  attachEventListeners() {
    // Use event delegation for dynamically loaded content
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.size-chart-trigger');
      if (trigger) {
        e.preventDefault();
        const img = trigger.querySelector('img');
        if (img && img.src) {
          this.openModal(img.src, img.alt || 'Size Chart');
        }
      }
    });

    // Also handle direct clicks on images inside size chart accordion
    document.addEventListener('click', (e) => {
      if (e.target.matches('.product__accordion img')) {
        const parentDetails = e.target.closest('details');
        if (parentDetails && parentDetails.id.includes('Details-collapsible_tab')) {
          // Check if this is a size chart by looking for keywords
          const heading = parentDetails.querySelector('.accordion__title');
          if (heading && heading.textContent.toLowerCase().includes('size')) {
            e.preventDefault();
            this.openModal(e.target.src, e.target.alt || 'Size Chart');
          }
        }
      }
    });
  }

  openModal(imageSrc, altText) {
    if (!this.modal || !this.modalImage) return;
    
    this.modalImage.src = imageSrc;
    this.modalImage.alt = altText;
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  closeModal() {
    if (!this.modal) return;
    
    this.modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }
}

// Initialize the size chart popup when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SizeChartPopup();
  });
} else {
  new SizeChartPopup();
}
